export enum FolderInfo {
  Photo = 'EA93C69C-A4E3-492B-AE92-017FB2AADDD9',
  Vault = 'F59BAA25-175B-4EB3-A76F-01806ED49357',
  EmergencyPrep = '03E3A8AB-7DD1-4C9E-A751-5959CB81DBA9',
  LegacyVideo = 'C66F09EE-F2A6-4CEC-BFB1-52D7C6DFD06E',
  DeathReport = '94185894-81a2-4f03-a95b-c5ec49cc85cc',
  EmergencyContacts = '0f6fd591-0c75-469a-b415-0181141e4a9a',
  PasswordManagerId = '752DEB28-6414-46B1-8A8A-01835B0B76F7',
  HealthCareProxy = '80EC2F22-25A1-4325-8BA7-F5C380DCAD50',
  PersonalFinanceId = '512FFE9C-63C5-4DB8-9299-01835602C15F'
}
